import React,{useState, useEffect} from "react";
import InstituteTemplate from "../../Components/InstituteTemplate/InstituteTemplate";
import InstituteAccountSecurity from "./Components/InstituteAccountSecurity/AccountSecurity";
import InstituteProfileSettings from "./Components/InstituteProfile/InstituteProfile";
import SchoolTimingsAndSchedule from "./Components/InstituteTimingsAndScedule/SchoolTimingsAndSchedule";
import InstitutePersonalNotifications from "./Components/Notifications/Notifications";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";
import InstituteDetails from "./Components/InstituteDetailsPage/InstituteDetails";
import { useSearchParams } from "react-router-dom";

const InstituteSettingsComponent = ({}) => {
    const [activeTab, setActiveTab] = useState("profile");

    const UserId = GetLocalStorage("UserInfo")?.UserId;
    console.log("UserId in SchoolTimingsAndSchedule is:",UserId);

    const Email = GetLocalStorage("UserInfo")?.Email;
    console.log("Email in SchoolTimingsAndSchedule is:",Email);

    // State to manage the active tab
    const [searchParams] = useSearchParams();
    const tabFromUrl = searchParams.get("tab"); // Get tab from URL   

    useEffect(() => {
        if (tabFromUrl==="School Timings") {
          setActiveTab("School Timings");
        }
      }, [tabFromUrl]);

    // Function to render the right-side content based on the active tab
    const renderContent = () => {
        switch (activeTab) {
            case "profile":
                return <InstituteProfileSettings />
            case "Account Security":
               return <InstituteAccountSecurity UserId={UserId} Email={Email} />
            case "School Timings":
               return <SchoolTimingsAndSchedule />
            case "Notifications":
                return <InstitutePersonalNotifications UserId={UserId} />
            case "Institute Details":
                return <InstituteDetails />
            default:
                return <InstituteProfileSettings />;
        }
    };

    return (
        <div className="w-full mt-[25px]">
            <div className="w-full pb-[15px]"
            style={{
                borderBottom: "1px solid #CECECE"
            }}
            >
                <p className="pl-[40px] text-[32px] text-[#4C34AD] font-bold">Settings</p>
            </div>

            <div className="w-full flex pb-[50px]">

                <div className="w-[30%] flex flex-col items-center gap-[25px] mt-[80px]">
                    <div className="flex flex-col items-start gap-[15px]">
                        <p
                            className={`text-[#2D2366] text-[22px] cursor-pointer font-bold pl-[20px] ${
                                activeTab === "profile" ? "bg-[#D9DAFF] rounded-[9px] pl-[20px] p-[7px] w-[250px]" : ""
                            }`}
                            onClick={() => setActiveTab("profile")}
                        >
                            Profile
                        </p>
                        <p
                            className={`text-[#2D2366] text-[22px] cursor-pointer font-bold pl-[20px] ${
                                activeTab === "Account Security" ? "bg-[#D9DAFF] rounded-[9px] pl-[20px] p-[7px] w-[250px] " : ""
                            }`}
                            onClick={() => setActiveTab("Account Security")}
                        >
                            Account Security
                        </p>
                        <p
                            className={`text-[#2D2366] text-[22px] cursor-pointer font-bold pl-[20px] ${
                                activeTab === "Subscriptions" ? "bg-[#D9DAFF] rounded-[9px] pl-[20px] p-[7px] w-[250px] " : ""
                            }`}
                            onClick={() => setActiveTab("Subscriptions")}
                        >
                            Subscription
                        </p>

                        <p
                            className={`text-[#2D2366] text-[22px] cursor-pointer font-bold pl-[20px] w-[250px] ${
                                activeTab === "School Timings" ? "bg-[#D9DAFF] rounded-[9px] pl-[20px] p-[7px] w-[280px] " : ""
                            }`}
                            onClick={() => setActiveTab("School Timings")}
                        >
                           Institute Timing & Class Schedule
                        </p>
                        <p
                            className={`text-[#2D2366] text-[22px] cursor-pointer font-bold pl-[20px] ${
                                activeTab === "Notifications" ? "bg-[#D9DAFF] rounded-[9px] pl-[20px] p-[7px] w-[250px] " : ""
                            }`}
                            onClick={() => setActiveTab("Notifications")}
                        >
                            Notification
                        </p>
                        <p
                            className={`text-[#2D2366] text-[22px] cursor-pointer font-bold pl-[20px] ${
                                activeTab === "Institute Details" ? "bg-[#D9DAFF] rounded-[9px] pl-[20px] p-[7px] w-[250px] " : ""
                            }`}
                            onClick={() => setActiveTab("Institute Details")}
                        >
                            Institute Details
                        </p>
                    </div>
                </div>

                <div 
                    className="w-[70%] p-[20px]"
                    style={{
                borderLeft: "1px solid #CECECE"
            }}>
                        {renderContent()}
                </div>
            </div>
        </div>
    );
};

const InstituteSettings = () => <InstituteTemplate Element={InstituteSettingsComponent} />;


export default InstituteSettings;
